<template>
  <div class="allClass">
    <div v-if="pageStr === 'subReplyListPage'">
      <div class="showSbContent" :style="{ height: subWindowHeight + 'vh' }">
        <el-scrollbar style="height: 100%;">
          <div
            v-for="(reply, index) in replaysArrayList"
            v-bind:key="reply.replyId"
            class="feedbackList"
          >
            <oneSubPostCom
              :reply="reply"
              :index="index"
              v-on:flushNowPostListEvent="flushFirstPageListFun"
            ></oneSubPostCom>
          </div>
        </el-scrollbar>
      </div>
      <div class="pagesAndAddButtonLayoutClass">
        <div id="subPosDiv">
          <el-pagination
            :hide-on-single-page="true"
            popper-class="subPostListPageComponentClass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[5, 10, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="sum"
          >
          </el-pagination>
        </div>
        <div style="padding-left: 40px;">
          <el-button size="small" type="primary" @click="showSaveComponent"
            >留言</el-button
          >
        </div>
      </div>
    </div>
    <div v-else-if="pageStr === 'saveReplyContentPage'">
      <updateOrSaveSubReplyCom
        :appendPostId="appendPostId"
        :componentFunction="'save'"
        v-on:flushNowPostListEvent="flushFirstPageListFun"
        v-on:goBackEvent="pageStr = 'subReplyListPage'"
      ></updateOrSaveSubReplyCom>
    </div>
  </div>
</template>

<script>
import updateOrSaveSubReplyCom from './subUpdateOrAdd/postUpdateOrSave.vue'
import oneSubPostCom from './onePost/subPostShow.vue'
export default {
  props: {
    appendPostId: Number,
    subReplyAppendPostContent: String
  },
  data () {
    return {
      sum: 0,
      nowPage: 1,
      pageSize: 5,
      replaysArrayList: null,
      pageStr: 'subReplyListPage',
      subWindowHeight: 28
    }
  },
  mounted () {
    // 根据父ID 获取所有的子回复
    this.flushDataList()
  },
  methods: {
    flushDataList () {
      const api = '/md/front/bbs/feedback/all/mainSub'
      const params = {
        nowPage: this.nowPage,
        pageSize: this.pageSize,
        userPostId: this.appendPostId
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.sum = res.data.sum
          this.replaysArrayList = res.data.list
        }
      })
    },
    handleCurrentChange (nowPage) {
      this.nowPage = nowPage
      this.flushDataList()
    },
    handleSizeChange (newPageSize) {
      this.pageSize = newPageSize
      this.flushDataList()
    },
    showSaveComponent () {
      this.pageStr = 'saveReplyContentPage'
    },
    flushFirstPageListFun () {
      this.nowPage = 1
      this.flushDataList()
    },
    // 返回主帖列表
    goBackFun () {
      this.$emit('goBackEvent')
    }
  },
  components: {
    updateOrSaveSubReplyCom,
    oneSubPostCom
  },
  watch: {
    replaysArrayList (newV, oldV) {
      if (this.sum > this.nowPage * this.pageSize) {
        this.subWindowHeight = 30
      } else if (this.sum < (this.nowPage - 1) * this.pageSize) {
        this.subWindowHeight = 0
      } else {
        this.subWindowHeight =
          (this.sum - (this.nowPage - 1) * this.pageSize) * 6
      }
    }
  }
}
</script>

<style scoped>
.allClass {
  text-align: left;
}
.showSbContent {
  margin-bottom: 1rem;
  height: 28vh;
}
.feedbackList {
  text-align: left;
}
.title {
  font-size: 1.5rem;
}
.pagesAndAddButtonLayoutClass {
  display: flex;
  justify-content: center;
}

#subPosDiv .el-pager li {
  background-color: #fff;
  font-size: 16px;
  color: #000;
}

#subPosDiv .el-pagination .btn-next,
.el-pagination .btn-prev {
  background-color: #fff;
  color: #000;
}
#subPosDiv .el-pagination button:disabled {
  background-color: #fff;
  color: #000;
}
#subPosDiv .el-pagination {
  color: #000;
}
#subPosDiv .el-pagination__total {
  font-weight: 500;
  color: #000;
}
#subPosDiv .el-pagination__jump {
  font-weight: 500;
  color: #000;
}
#subPosDiv .el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #000;
}
#subPosDiv .el-pager li.active {
  color: blue;
}
#subPosDiv .el-pager li.btn-quicknext,
.el-pager li.btn-quickprev {
  line-height: 28px;
  color: #000;
}

#subPosDiv .el-input__inner {
  background-color: transparent;
  color: #000;
}

#subPosDiv .el-scrollbar__wrap {
  overflow-x: hidden;
}

#subPosDiv .el-pagination .el-input__inner {
  color: #000;
}

#subPosDiv :deep(.el-pagination .el-input__inner) {
  color: #000;
}

#subPosDiv :deep(.el-pagination .btn-next .el-icon),
#subPosDiv :deep(.el-pagination .btn-prev .el-icon) {
  color: #000;
}

#subPosDiv :deep(.el-pagination__total),
#subPosDiv :deep(.el-pagination__jump) {
  color: #000;
}
</style>
